import { render, staticRenderFns } from "./SessionTemplateGrid.vue?vue&type=template&id=787da971&"
import script from "./SessionTemplateGrid.vue?vue&type=script&lang=ts&"
export * from "./SessionTemplateGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports